import arrayMapper from '../../mixins/arrayMapper';
import { mixin } from '../../helpers/object';
import { rangeEach } from '../../helpers/number';

/**
 * 行索引映射器（筛选专用）。
 *
 * 与 columnSorting/rowsMapper 同构：_arrayMap 的下标是"可视行号"，
 * 值是"物理行号"。筛选的本质就是让 _arrayMap 只保留通过筛选的物理行，
 * 从而使 countRows 变小、modifyRow 把可视行号翻译到真实数据行。
 *
 * @class RowsMapper
 */
class RowsMapper {
  /**
   * 重建为恒等映射（不过滤任何行）。
   *
   * @param {Number} [length] 映射长度，默认沿用当前长度。
   */
  createMap(length) {
    const originLength = length === void 0 ? this._arrayMap.length : length;

    this._arrayMap.length = 0;

    rangeEach(originLength - 1, (itemIndex) => {
      this._arrayMap[itemIndex] = itemIndex;
    });
  }

  /**
   * 按给定的物理行号数组重建映射（即筛选结果）。
   *
   * @param {Number[]} physicalRows 通过筛选的物理行号，需已按升序排列。
   */
  setMap(physicalRows) {
    this._arrayMap.length = 0;

    for (let i = 0; i < physicalRows.length; i++) {
      this._arrayMap[i] = physicalRows[i];
    }
  }

  destroy() {
    this._arrayMap = null;
  }
}

mixin(RowsMapper, arrayMapper);

export default RowsMapper;
